module.exports = __webpack_public_path__ + "static/media/facebook.54f8652f.svg";